import React from 'react';
import { Form as BSForm } from 'react-bootstrap';
import { getIn, useFormikContext } from 'formik';

const ChoicePreview = ({ choice, field, checkClass, index, sendSurvey, outOfDate, inputType = 'radio' }) => {
  const { setFieldValue, values, setFieldTouched } = useFormikContext();

  const setChoice = () => {
    setFieldTouched(`employeeSurvey[employeeQuestionChoicesAttributes][${index}][questionId]`);
    const path = `employeeSurvey[employeeQuestionChoicesAttributes][${index}][questionChoiceId]`;
    const currentValue = getIn(values, path);

    if (inputType === 'checkbox') {
      const arr = Array.isArray(currentValue) ? currentValue : [];
      if (arr.includes(String(choice.id))) {
        setFieldValue(path, arr.filter(id => id !== String(choice.id)));
      } else {
        setFieldValue(path, [...arr, String(choice.id)]);
      }
    } else {
      setFieldValue(path, String(choice.id));
    }
  };

  const selected = () => {
    const value = getIn(values, `employeeSurvey[employeeQuestionChoicesAttributes][${index}][questionChoiceId]`);
    if (inputType === 'checkbox') {
      const arr = Array.isArray(value) ? value : [];
      return arr.includes(String(choice.id)) ? 'selected' : '';
    }
    return value && String(value) === String(choice.id) ? 'selected' : '';
  };

  const isChecked = !!selected();

  return (
    <div className="mr-3 my-3 py-0">
      <BSForm.Check
        type={inputType}
        id={`choice-${choice.id || choice.position}`}
        className={`${checkClass} ${selected()}`}
        name={field.name}
        label={<span className="font-weight-bold dark">{choice.label}</span>}
        onChange={setChoice}
        checked={isChecked}
        disabled={!sendSurvey || outOfDate}
      />
    </div>
  );
};

export default ChoicePreview;
